<div class="flex flex-col gap-4 mt-2">
  <ng-container *ngFor="let email of emailRecipients.controls; let i = index">
    <flow-email-sendouts-item
      [control]="email"
      [canRemove]="emailRecipients.length > 1"
      [disabled]="!isEditMode"
      (remove)="removeEmailRecipient(i)"></flow-email-sendouts-item>
  </ng-container>

  <flow-button class="mb-1" theme="primary" (onClick)="addEmailRecipient()" [disabled]="isAddDisabled">
    <span>{{ 'global.add' | translate }}</span>
  </flow-button>
</div>
